<cm-action-panel #infoPanel arrowRight="13px" minWidth="250px" maxWidth="250px">
    <cm-action-panel-row cmIconClass="far fa-up-right-and-down-left-from-center">
        {{ $width() }} px × {{ $height() }} px
        @if ($size(); as size) {
            ({{ size | filesize: {base: 2} }})
        }
    </cm-action-panel-row>
    <cm-action-panel-row cmIconClass="far fa-magnifying-glass">{{ zoomLevel() }}%</cm-action-panel-row>
</cm-action-panel>
<cm-action-bar>
    <ng-container cm-action-items>
        <ng-content select="[cm-action-items-pos1]"></ng-content>
        <cm-action-item (click)="navigation()?.physicalZoomTo(1)" tooltip="Zoom to 100%" cmIconClass="far fa-expand"></cm-action-item>
        <cm-action-item (click)="navigation()?.zoomToFitImage()" tooltip="Zoom to fit" cmIconClass="far fa-compress"></cm-action-item>
        <cm-action-item tooltip="Download" cmIconClass="far fa-arrow-to-bottom" [matMenuTriggerFor]="downloadPictureMenu">
            <mat-menu #downloadPictureMenu="matMenu">
                @if ($imageData()) {
                    <button mat-menu-item (click)="downloadFromImageData('png')">PNG</button>
                    <button mat-menu-item (click)="downloadFromImageData('jpeg')">JPEG</button>
                    <button mat-menu-item (click)="downloadFromImageData('tiff')">TIFF</button>
                    <button mat-menu-item (click)="downloadFromImageData('exr')">EXR (Raw)</button>
                }
            </mat-menu>
        </cm-action-item>
        <ng-content select="[cm-action-items-pos2]"></ng-content>
        <cm-action-item [showPanelByDefault]="!$isMobileDevice()" tooltip="Info" [panel]="infoPanel" cmIconClass="far fa-info-circle"></cm-action-item>
    </ng-container>
</cm-action-bar>
